export const COLORS = {
  danger: '#F64E60',
  initial: '#353535',
};
